import React,{useEffect,useState} from 'react';
import {Switch,Route,Redirect} from 'react-router-dom';
import {CircularProgress, Typography} from '@mui/material';
import {styles} from '../Theme/globalStyles';
import GlobalStyles from '@mui/material/GlobalStyles';

import {TimeoutDialog} from '../Components/CommonComponents/DialogBox'
import Logout from '../Components/CommonComponents/Logout';
import AnalystRoutes from './AnalystRoutes';
import ResearcherRoutes from './ResearcherRoutes';
import AdministratorRoutes from './AdministratorRoutes';

import Localization from '../HoC/Localization';
import {useTranslation} from 'react-i18next';

import { UserRole } from '../ApplicationConfig/constants';
import {UserInfoContext, defaultUserInfoValues} from "../StateObjects/UserInfoContext";
import {ProjectInfoContext, defaultProjectInfoValues} from "../StateObjects/ProjectInfoContext";
import {UserPreferencesContext, defaultUserPreferences} from "../StateObjects/UserPreferencesContext";
import {CodesetsContext, defaultCodesetsContext} from "../StateObjects/CodesetsContext";

import {Auth} from '../Api/auth'
import {useStateWithLocalStorage} from '../Api/functions';

import SignOut from '../Components/AzureAD/SignOut';

import { useMsal } from '@azure/msal-react';

export default function InitializeRoutes(){
  const [pageStatus,setPageStatus]=useState({
    dataLoaded:false,
    errorMessageKey:'',
    component:null
  });
  const [validWindowTab,setValidWindowTab]=React.useState(true)
  const [projectInfo, setProjectInfo] = useStateWithLocalStorage("projectInfo",defaultProjectInfoValues)
  const [userInfo, setUserInfo] =useStateWithLocalStorage("userInfo",defaultUserInfoValues)
  const [userPreferences, setUserPreferences] =useStateWithLocalStorage("userPreferences",defaultUserPreferences)
  const [codesets, setCodesets] =useStateWithLocalStorage("codesets",defaultCodesetsContext)
  const {t}=useTranslation();
  const {instance}=useMsal();

  useEffect(() => {

    Auth.authorizedFetch("/api/getUserInfo",{},instance)
    .then(res => res.json())
    .then((result) => {
      if (result.statusCode==200){
          //if project is not set OR a change of user occured
        if (projectInfo.id == -1 || (userInfo.id!=undefined && result.data.user.id != userInfo.id)){
        
          //const token=Auth.token();
          sessionStorage.clear();

          //Auth.login(token);

          let project = result.data.user.projects.find(proj=>proj.id===result.data.selectedProjectId);
          if(project){
            setProjectInfo(project);
          }
          
        }
        // if the project set in UI isnt the same that the one recorded in session
        else if (projectInfo.id != -1 && result.data.selectedProjectId != projectInfo.id){
          //reset back the project in UI according to the one set in session
          let project = result.data.user.projects.find(proj=>proj.id===result.data.selectedProjectId);
          if(project){
            setProjectInfo(project);
          }
        }
        
        setUserInfo({...result.data.user});
        
        setCodesets(result.data.codesets)
        
        setPageStatus({...pageStatus,dataLoaded:true});
      }
      else{
        if (result.customMessageKey=="applicationErrorMessage.generic.userNotExistDatabase")
        {
          Auth.logout();
        }
        
        setPageStatus({
          ...pageStatus,
          dataLoaded:false,
          errorMessageKey:result.customMessageKey.length===0 ? 'applicationErrorMessage.generic.unexpectedBrowserError' : result.customMessageKey,
          component:<React.Fragment />
        });
      }
    })
    .catch((error) => {
      console.log(error)
      setPageStatus({...pageStatus,dataLoaded:false,errorMessageKey:'applicationErrorMessage.generic.unexpectedBrowserError'});
    })
  }, [])

  React.useEffect(()=>{
    if (!validWindowTab){
      document.title=t('inactiveWindowTabTitle')
    }
  },[validWindowTab])

  return(
    <>
      <GlobalStyles styles={styles} />
      {validWindowTab && 
        <UserInfoContext.Provider value={{userInfo, setUserInfo:setUserInfo}}>
          <UserPreferencesContext.Provider value={{userPreferences,setUserPreferences:setUserPreferences}}>
            <CodesetsContext.Provider value={{codesets,setCodesets:setCodesets}}>
              <Switch>
                <Route exact path="/">
                    <Redirect from='/' to='/en/home' /> 
                </Route>
                <Route exact path="/SignOut">
                  <SignOut />
                </Route>
                <Route path="/:lang(en|fr)?">
                  {pageStatus.dataLoaded && 
                    <Localization>
                      <ProjectInfoContext.Provider value={{projectInfo, setProjectInfo:setProjectInfo}}>
                        {(userInfo.role==UserRole.Analyst && <AnalystRoutes />) || 
                        (userInfo.role==UserRole.Researcher && <ResearcherRoutes />) || 
                        (userInfo.role==UserRole.Admin && <AdministratorRoutes />)
                        }
                      </ProjectInfoContext.Provider>
                      <TimeoutDialog setValidWindowTab={setValidWindowTab} />
                    </Localization>
                  }
                  {!pageStatus.dataLoaded && pageStatus.errorMessageKey.length==0 &&
                    <div style={{height:'100vh',display: 'flex',alignItems:'center',justifyContent:'center'}}>
                      <CircularProgress />
                    </div>
                  }
                  {pageStatus.errorMessageKey.length>0 && 
                  <Localization>
                    <div style={{height:'100vh',display: 'flex',alignItems:'center',justifyContent:'center'}}>
                    <Typography>{(pageStatus.errorMessageKey=="applicationErrorMessage.generic.userNotExistDatabase" && <>{t(pageStatus.errorMessageKey)} <a href="https://portal.azure.com" >{t('site.azurePortal')}</a>.</>) ||
                    t(pageStatus.errorMessageKey) }</Typography>
                    </div>
                    </Localization>
                  }
                </Route>
              </Switch>
            </CodesetsContext.Provider>
          </UserPreferencesContext.Provider>
        </UserInfoContext.Provider>
      }
      {!validWindowTab && 
        <Localization>
          <div style={{height:'100vh',display: 'flex',alignItems:'center',justifyContent:'center'}}>       
            <Typography>{t('applicationErrorMessage.generic.tabInactive')}</Typography>
          </div>
        </Localization>
      }
    </>
  )
}